<script>
  /* Executable code section of the program */
  //Tools importation
  import { isAlertOn,alertMessagge,isReloadNecessary } from "../../apis/storage";

  //Auxiliary varibles

  //Function to undisplay alert
  if ($isReloadNecessary) {
  setTimeout(()=>{
    $isAlertOn = false;
    location.reload()
  },3000)
  } else {
  setTimeout(()=>{
    $isAlertOn = false;
  },3000)
  }

  /* End of the section */
</script>

<section class="principalContainer">
  <div class="alertContainer">
    <p>{$alertMessagge}</p>
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal Container */
  .principalContainer {
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20dvh;
    z-index: 999;
    padding: 10px;/* 
    background-color: rgba(0, 0, 0, 0.164); */
  }
  /* Container */
  .alertContainer {
    text-align: center;
    background-color: white;
    width: 50%;
    height: auto;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border: 1px solid gray;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .alertContainer{
      width: 80%;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .alertContainer{
      width: 100%;
    }
  }
  /* End of the section */
</style>
